import { render, staticRenderFns } from "./TrackingDetails.vue?vue&type=template&id=4862af17&"
import script from "./TrackingDetails.vue?vue&type=script&lang=js&"
export * from "./TrackingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4862af17')) {
      api.createRecord('4862af17', component.options)
    } else {
      api.reload('4862af17', component.options)
    }
    module.hot.accept("./TrackingDetails.vue?vue&type=template&id=4862af17&", function () {
      api.rerender('4862af17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tracking/TrackingDetails.vue"
export default component.exports